module.exports = __webpack_public_path__ + "img/jane.dcbf8768.png";